export default __webpack_public_path__ + "static/media/112.2e795104.png";